import { Deposito } from './../../../../models/cad/deposito/deposito';
import { Validators } from '@angular/forms';
import { Component, Injector, OnInit, Inject,ViewChild, ElementRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, startWith, map } from 'rxjs';
import { Acesso } from 'src/app/models/bas/acesso/acesso';
import { Cliente } from 'src/app/models/cad/cliente/cliente';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CustomSnackBarService } from 'src/app/shared/components/custom-snack-bar/custom-snack-bar.service';
import { TrataExcessao } from 'src/app/shared/utils/trata-excessao';
import { DepositoService } from 'src/app/services/cad/deposito.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { EstoqueService } from 'src/app/services/est/estoque.service';
import { MatTableDataSource } from '@angular/material/table';
import { Estoque } from 'src/app/models/est/estoque/estoque';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { formatDate } from "@angular/common";


@Component({
  selector: 'app-filtro-estoque',
  templateUrl: './filtro-estoque.component.html',
  styleUrls: ['./filtro-estoque.component.scss']
})
export class FiltroEstoqueComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  @ViewChild("inputFiltro") inputFiltro: ElementRef;
  dataSourceEtiqueta = new MatTableDataSource<never>();

  selectedEstoque: Estoque | null = null;

  filterObject;


  dataSource = new MatTableDataSource<Estoque>();

  dialogRef: MatDialogRef<FiltroEstoqueComponent>;


  private dialogData;

  form: UntypedFormGroup;
  cliente: Cliente;

  isLoading = false;
  acesso: Acesso | undefined = undefined;
  countLoading = 0;
  nameDeposito

  separatorKeysCodes: number[] = [ENTER, COMMA];

  listaDeposito: Array<Deposito> = [];
  listaTodosDepositos: Array<Deposito> = [];
  listaDepositoFiltrados: Array<Deposito> = [];
  listaDepositoOpcoesFiltradas: Array<Deposito> = [];

  depositoSelecionado: boolean = false;
  registro;

  constructor(
    private injector: Injector,
    private formBuilder: UntypedFormBuilder,
    private snackBar: CustomSnackBarService,
    private authService: AuthService,
    private depositoService: DepositoService,
    private service: EstoqueService,
    @Inject(SESSION_STORAGE) private storage: StorageService

  ) {

    this.dialogRef = this.injector.get(MatDialogRef);
    this.dialogData = this.injector.get(MAT_DIALOG_DATA, null);
  }

  private createForm() {
    this.form = this.formBuilder.group({
      deposito: [, /*Validators.required*/],
      nomeDeposito: [,],
      dataReferencia: [,],
    });
  }

  private pesquisarDeposito() {
    this.depositoService.listarTodos().subscribe((response) => {
      if (response.body.retorno) { 

        this.listaDeposito        = response.body.retorno.registro;
        this.listaTodosDepositos  = response.body.retorno.registro;

        if (this.dialogData && this.dialogData['listaDepositos'] ) {
          const depositoSelecionados = this.dialogData['listaDepositos'];
          //this.listaDepositoFiltrados = depositoSelecionados;
          for (let j of depositoSelecionados) {
            const element = this.listaDeposito.find((item) => item.codigoDeposito === j.codigoDeposito);            
            if (element) {
              this.listaDepositoFiltrados.push(element);
              const index = this.listaDeposito.indexOf(element);
              this.listaDeposito.splice(index, 1);
            }
          }
        }
        if (this.dialogData && this.dialogData['dataReferencia'] ) {
          this.form.controls['dataReferencia'].setValue(this.dialogData['dataReferencia']);

        }
        this.listaDepositoOpcoesFiltradas = this.listaDeposito.slice();
      }
    }, (err) => {
      TrataExcessao.TrataExcessao(err, this.authService, this.snackBar);
    }
    );
  }

  saveInSession(key, val): void {
    this.storage.set(key, val);
  }

  listaEstoqueAtivo(result?: Array<any>) {
    if (result) {
      this.dataSource = new MatTableDataSource<Estoque>(result);
      return;
    }
    this.saveInSession("filtroEstoque", this.filterObject);
    this.service.listarEstoqueAtivo(this.filterObject).subscribe(
      (response) => {
        this.dataSource = new MatTableDataSource<Estoque>(response.body.retorno.registro);
        this.registro = response.body.retorno.registro;
        setTimeout(() => {
          this.dataSource.filterPredicate = (
            data: { nomeDeposito: string; },
            filterValue: string
          ) => data.nomeDeposito.toString().trim().toLowerCase().indexOf(filterValue) !== -1

          var filtroBuscar = this.getFromSession("filtroBuscarEstoque");  
          if (filtroBuscar) {
            this.inputFiltro.nativeElement.value = filtroBuscar;
            this.applyFilter(filtroBuscar); 
          } 

          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        });
        this.trataRetornoPesquisaEstoque();
      },
      (err) => {
        TrataExcessao.TrataExcessao(err, this.authService, this.snackBar);
      }
    );
  }
  
  trataRetornoPesquisaEstoque() {
    setTimeout(() => {
      this.dataSource.filterPredicate = (
        data: {
          produtoCod: string,
          nomeProduto: string,
          nomeDeposito: string,
          quantidadeRequisitada: string,
        },
        filterValue: string
      ) => data.nomeProduto.toString().trim().toLowerCase().indexOf(filterValue) !== -1 ||
           data.produtoCod.toString().trim().toLowerCase().indexOf(filterValue) !== -1 ||
           data.nomeDeposito.toString().trim().toLowerCase().indexOf(filterValue) !== -1 ||
           data.quantidadeRequisitada.toString().trim().toLowerCase().indexOf(filterValue) !== -1 


      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });

    //Manter Aberto Estoque Que Foi Detalhado
    var achouListada = false;

    this.dataSource.data.forEach((estoque) => {
      if (estoque.codigoEstoque === this.selectedEstoque?.codigoEstoque) {
        this.selectedEstoque = estoque;
        this.groupHeaderClick(estoque);
        achouListada = true;
      }
    });

    if (!achouListada) {
      this.selectedEstoque = null;
    }
  }

  displayDeposito(deposito: Deposito): any {
    return deposito && deposito.nomeDeposito ? deposito.nomeDeposito : '';
  }

  groupHeaderClick(row: Estoque) {
    row.expanded = !row.expanded;

    if (row.expanded) {
      this.selectedEstoque = row;
    }
    else {
      this.selectedEstoque = null;
    }

    this.dataSourceEtiqueta = new MatTableDataSource<never>(row.etiquetas);

    this.dataSource.data.forEach((estoque) => {
      if (estoque.codigoEstoque != row.codigoEstoque) {
        estoque.expanded = false;
      }
    });

  }

  applyFilter(value: string) {
    this.dataSource.filter = value.trim().toLowerCase();
    this.saveInSession("filtroBuscarEstoque", value.trim().toLowerCase());
  }


  filtraDeposito(value: string) {
    const filtro = (value || '').trim().toLowerCase();
    this.listaDepositoOpcoesFiltradas = filtro
      ? this.listaDeposito.filter(item => item.nomeDeposito.toLowerCase().includes(filtro))
      : this.listaDeposito.slice();
  }

  selecionaDeposito(event, input: HTMLInputElement) {      
    let selecionado: Deposito = event.option.value;    
    const index = this.listaDeposito.indexOf(selecionado);
    if (index >= 0) {
      this.listaDepositoFiltrados.push(selecionado);
      this.listaDeposito.splice(index, 1);
    }
    input.value = '';
    this.filtraDeposito('');
  }

  remove(deposito: any): void {
    const index = this.listaDepositoFiltrados.indexOf(deposito);
    if (index >= 0) {
      this.listaDeposito.push(deposito);
      this.listaDepositoFiltrados.splice(index, 1);
    }
    this.filtraDeposito('');
  }

  private preencheCombos() {
    this.pesquisarDeposito();
  }


  /*closeModal() {
    
    let gridRegistrosFiltrados: Array<any> = [];
    if (this.listaDepositoFiltrados.length > 0) {
      const filtro = { nomeDeposito: this.listaDepositoFiltrados }
      for (let j of this.dialogData.registros) {
        const registro = this.listaDepositoFiltrados.find((item) => item === j.nomeDeposito);
        if (registro) {
          gridRegistrosFiltrados.push(j);
        }
        this.dialogRef.close({ gridRegistrosFiltrados, filtro });
      }
    } else {
      this.dialogRef.close();
    }

  }*/
    closeModal() {

      this.filterObject = {};

      if(this.form.valid){

        const obj = this.form.getRawValue();
        this.filterObject.listaDepositos = this.listaDepositoFiltrados;
        this.filterObject.dataReferencia = obj.dataReferencia; //formatDate(obj.dataReferencia, "MM/dd/yyyy","en-US") ;

        this.dialogRef.close(this.filterObject);
      } else {
        this.snackBar.openSnackBar('Campos obrigatórios não foram preenchidos.', 'Error');
      }
      }

  getFromSession(key): any {
    return this.storage.get(key);
  }

  ngOnInit(): void {
    this.createForm();
    this.preencheCombos();
    this.form.controls['nomeDeposito'].valueChanges.subscribe(deposito => {
      if (deposito === "") {
        this.form.controls['nomeDeposito'].setValue(null);
      }
    })
    var aux = this.getFromSession("filtroEstoque");
    if (aux)
      this.filterObject = aux;

  }

}
